module.exports = __webpack_public_path__ + "static/media/forest-world-full.ceda6f26.jpg";